import { useLayout } from '../core';
const Footer = () => {
    const { classes } = useLayout();
    return (<div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div className={`${classes.footerContainer} d-flex flex-column flex-md-row flex-stack`}>
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1'>
          <span className='text-gray-400 fw-bold me-1'>Copyright 2023 © </span>
          <a href='https://www.vtsl.net' target='_blank' className='text-muted text-hover-primary fw-bold me-2 fs-6'>
          VTSL 
          </a>
          <span className='text-gray-400 fw-bold me-1'>All rights reserved.</span>
        </div>
        {/* end::Copyright */}

        {/* begin::Menu */}
        <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          <li className='menu-item'>
            <a href='https://www.vtsl.net' target='_blank' className='menu-link px-2'>
              About
            </a>
          </li>
          <li className='menu-item'>
            <a href='https://www.vtsl.net/about/contact-us/' target='_blank' 
              className='menu-link px-2'>
              Contact
            </a>
          </li>
          <li className='menu-item'>
            <a href='https://www.vtsl.net/product-overview/voip-telephony/' target='_blank'
              className='menu-link px-2'>
              Purchase
            </a>
          </li>
        </ul>
        {/* end::Menu */}
      </div>
      {/* end::Container */}
    </div>);
};
export { Footer };
